<template>
    <div v-if="type == 'renew'">
        <div class="item-custom">
            <div class="flex justify-between items-start">
                <div class="icon-custom" :class="[item?.policyCategory.toLowerCase() == 'motor' ? 'car' : 'non_motor']"></div>
                <div class="right-col-custom">
                    <div class="info">
                        <div class="flex flex-col gap-1">
                            <div class="title">{{item.name}}</div>
                            <div class="no">{{ item.policyNo }}</div>
                        </div>
                        <div v-if="item.url" class="flex items-center justify-end pt-1">
                            <div class="bg-a-orange-fe5000 rounded-full p-2 text-center text-white text-12 w-1/2 h-7.5" @click="clickOpenLink(item.url)">ดาวน์โหลดใบเตือน</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="item-custom" 
        :class="[!isConfirm && isConfirm != undefined && isConfirm != null ? 'rounded-2xl border border-a-orange-fe5000 shadow-orange':'']" 
        v-else-if="item.doc.supDocType == 'FullCustomer'">
        <div class="flex justify-between items-start">
            <div class="icon-custom" :class="[item?.policy?.policyCategory != '' ? iconClassFullCustommer : iconClass]"></div>
            <div class="right-col-custom">
                <div>
                    <div class="info">
                        <div class="flex items-center justify-between">
                            <div class="title" :class="[!isConfirm && isConfirm != undefined && isConfirm != null ? 'w-44':'']">{{item.policy.policyType}}</div>
                            <div class="flex items-center bg-a-orange-FFE8D8 rounded-full w-fit py-1 px-2" v-if="!isConfirm && isConfirm != undefined && isConfirm != null">
                                <img class="max-m-375:w-4 max-m-375:h-4" src="@/assets/icon/ic-clock.svg" alt="">
                                <div class="pl-1 max-m-375:pl-0.5 text-a-orange-fe5000 font-bold text-12 max-m-375:text-11">รอยืนยัน</div>
                            </div>
                        </div>
                        <div class="plate">{{plan}}</div>
                        <div :class="(isConfirm == null || isConfirm == undefined) ? 'flex items-center justify-between':''">
                            <div class="no">เลขที่ {{item.policy.policyNo}}</div>
                            <div v-if="(isConfirm == null || isConfirm == undefined)">
                                <div class="bg-a-orange-fe5000 rounded-full p-2 text-center text-white text-12 w-20 h-7.5" @click="clickDownloadPolicy">ดาวน์โหลด</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pt-4" v-if="isConfirm && isConfirm != undefined && isConfirm != null">
                    <div class="flex  items-center " :class="[jacketUrl == null ? 'justify-end':'justify-between']">
                        <div class="text-12 text-a-orange-f36e21 underline w-1/2" @click="clickCondition()"  v-if="jacketUrl != null">เงื่อนไขความคุ้มครอง</div>
                        <div class="bg-a-orange-fe5000 rounded-full w-1/2 h-38px py-2.5 px-2 text-center text-white text-12 leading-normal" @click="clickDownloadPolicy()">ดาวน์โหลดกรมธรรม์</div>
                    </div>
                    <div v-if="item.policy.endosements.length > 0">
                        <div class="border-t border-a-gray-efefef w-full max-w-lg absolute left-0 right-0 mx-auto"></div>
                        <Endosements class="mt-6 -ml-12"
                            v-for="(i,k) of item.policy.endosements"
                            :key="k"
                            :itemEndosement="i"
                        ></Endosements>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-4 m-auto" v-if="!isConfirm && isConfirm != undefined && isConfirm != null">
            <div class="bg-a-orange-fe5000 rounded-full w-full p-3 text-center text-white text-12 flex items-center justify-center" @click="clickDownloadPolicy()">
                <div class="px-1">ตรวจสอบความคุ้มครอง</div>
                <img class="px-1" src="@/assets/icon/edocument/ic-arrow-white.svg" alt="">
            </div>
        </div>
    </div>
    <div class="item" v-else>
        <div class="icon" :class="iconClass"></div>
        <div class="right-col">
            <div class="info" v-if="type != 'ecard'">
                <div class="title">{{item.policy.policyType}}</div>
                <div class="plate">{{plan}}</div>
                <div class="no">เลขที่ {{item.policy.policyNo}}</div>
            </div>

            <div class="info" v-if="type == 'ecard'">
                <div class="title">E-Care Card</div>
                <div class="plate">{{ item.doc.name }}</div>
            </div>

            <div class="download_wrapper">
                <div class="download" v-if="type != 'ecard'" @click="clickDownloadPolicy">ดาวน์โหลด</div>
                <div class="download" v-if="type == 'ecard'" @click="clickOpenEcareTMB">ดาวน์โหลด</div>
            </div>

        </div>
    </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue';
import { useTracking } from "@/feature/TrackingFeature"

import Endosements from "../component/Endosements.vue"
export default defineComponent({
    props: {
        type: {
            type: String,
        },
        item: {
            type: Object,
        },
        isConfirm: { type: Boolean },
        isNotConfirm: { type: Boolean },
        isConfirmNull: { type: Boolean },
    },
    components: {
        Endosements
    },
    setup: function (props) {
        const tracking = useTracking()
        const jacketUrl = ref(props.item?.policy?.jacket?.url)
        const plan = computed(() => {
            if (!props.item.policy) {
                return "empty";
            }
            if (props.item.policy.mainClass == "2") {
                if (props.item.policy.policyDesc.length > 2) {
                    return props.item.policy.policyDesc[2].detail;
                }
            } else {
                if (props.item?.policy?.policyCategory?.toLowerCase() == 'motor') {
                    return props.item.policy.policyDesc[2].detail;
                }
            }
            return "";
        })

        const iconClass = computed(() => {
            if (!props.item.policy) {
                return "empty";
            }
            if (props.type == 'ecard'){
                return "ecare_card";
            }
            if (props.item.policy.mainClass == "6") {
                return "tmb";
            }
            if (props.item.policy.mainClass == "2") {
                return "car";
            }
            if (props.item.policy.mainClass == "") {
                return "tmb";
            }
            return "empty";
        })
        const iconClassFullCustommer = computed(() => {
            if (props.item?.policy?.policyCategory?.toLowerCase() == 'motor') {
                return "car";
            }
            if (props.item?.policy?.policyCategory?.toLowerCase() == 'nonmotor') {
                return "non_motor";
            }
            return "empty";
        })

        function clickDownloadPolicy() {
            if (props.type == 'tax'){
                tracking.event("edocument_list_page", "click_download_edocument", "TaxExp", "");
            } else {
                tracking.event("edocument_list_page", "click_download_edocument", "FullCustomer", "");
            }

            let data = props.item.doc;
            let url = "";
            if (data && data.url) {
                url = data.url;
            }
            if (url) {
                if (url.indexOf('?') < 0) {
                    window.open(url + '?openExternalBrowser=1', '_blank');
                } else {
                    window.open(url + '&openExternalBrowser=1', '_blank');
                }
            }
            return;
        }

        function clickOpenEcareTMB() {
            tracking.event("edocument_list_page", "click_download_edocument", "EPACARD", "");
            let data = props.item.doc;
            let url = data.url;
            try {
                if (url.indexOf('?') < 0) {
                    window.open(url + '?openExternalBrowser=1', '_blank');
                } else {
                    window.open(url + '&openExternalBrowser=1', '_blank');
                }

            } catch (e) {
                console.log(e.message);
                window.location = url;
            }
            return;
        }

        function clickCondition() {
            window.open(jacketUrl.value, '_blank')
        }

        const clickOpenLink = (url) => {
            window.open(url, '_blank')
        }

        return {
            iconClass,
            plan,
            clickDownloadPolicy,
            clickOpenEcareTMB,
            clickCondition,
            iconClassFullCustommer,
            jacketUrl,
            clickOpenLink
        }
    }
})
</script>

<style lang="scss" scoped>
.item {
    @apply bg-white mb-3 mx-2.5 p-4  flex;
    border-radius: 16px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

    .icon {
        @apply  mr-2 block w-12 h-12 bg-a-orange-fe5000 rounded-full overflow-hidden;
        &.tmb {
            background: url(../../../assets/icon/edocument/person.svg) no-repeat center center;
            background-size: 100%;
        }
        &.car {
            background: url(../../../assets/icon/edocument/car.svg) no-repeat center center;
            background-size: 100%;
        }
        &.ecare_card {
            background: url(../../../assets/icon/edocument/ecare_card.svg) no-repeat center center;
            background-size: 100%;
        }
        &.non_motor {
            background: url(../../../assets/icon/edocument/ic-cate-non-motor.png) no-repeat center center;
            background-size: 100%;
        }
    }
    .right-col{
        @apply flex justify-between items-center;
        width: calc(100% - 56px);

        .info {
            .title {
                @apply text-16 text-a-black-555555;
            }
            .plate {
                @apply  py-1 text-12 text-a-black-484848;
            }
            .no {
                @apply  pt-1 text-12 font-light text-a-black-484848;
            }
        }
        .download {
            @apply  bg-a-orange-fe5000 text-12 text-white flex justify-center items-center w-20 h-7.5 rounded-full;
        }
        .download_wrapper {
            @apply flex justify-center items-end h-full;
        }
    }
}
.item-custom {
    @apply bg-white mb-3.5 mx-2.5 p-4;
    border-radius: 16px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

    .icon-custom {
        @apply  mr-2 block w-14 h-14 bg-a-orange-fe5000 rounded-full overflow-hidden;
        &.tmb {
            background: url(../../../assets/icon/edocument/person.svg) no-repeat center center;
            background-size: 100%;
        }
        &.car {
            background: url(../../../assets/icon/edocument/car.svg) no-repeat center center;
            background-size: 100%;
        }
        &.ecare_card {
            background: url(../../../assets/icon/edocument/ecare_card.svg) no-repeat center center;
            background-size: 100%;
        }
        &.non_motor {
            background: url(../../../assets/icon/edocument/ic-cate-non-motor.png) no-repeat center center;
            background-size: 100%;
        }
    }
    .right-col-custom {
        @apply w-full;
        // width: calc(100% - 66px);

        .info {
            .title {
                @apply text-14 text-a-black-555555;
            }
            .plate {
                @apply  py-1 text-12 text-a-black-484848;
            }
            .no {
                @apply  pt-1 text-12 font-light text-a-black-484848;
            }
        }
    }
}
</style>
